import { HaloPSAConnectFormValue } from "@/Contracts/Settings";
import {
	getRequest,
	postRequest,
	putRequest
} from "@/Utils/Service/BackendService";
import {
	HaloIntegrationRequest,
	HaloPSAAuthDetails,
	HaloPSAMetadata,
	HaloPSAUpdateAndDeleteResponse,
	TaxInfo,
	TestHaloPSACredentialsResponse
} from "@pages/Integrations/HaloPSAIntegration/interface";
import axios, { AxiosResponse } from "axios";

const TestHaloPSACredentialsURL = "/v2/companies/integration/halo/test_cred/";
const FetchHaloPSAMetadataURL = "/v2/companies/integration/halo/metadata/";
const ImportTaxInfoURL = "v2/companies/integration/halo/tax/import/";
const AddHaloIntegrationURL = "/v2/companies/integration/halo/";
const DeleteHaloPSAIntegrationURL = "/v2/companies/integration/halo/delete/";
const FetchHaloPSAAuthDetailsURL = "/v2/companies/integration/halo/cred/";

export const testHaloPSACredentials = async (
	authDetails: HaloPSAConnectFormValue
): Promise<TestHaloPSACredentialsResponse> => {
	try {
		const testHaloPSACredentialsResponse: AxiosResponse<TestHaloPSACredentialsResponse> =
			await axios(
				postRequest(
					TestHaloPSACredentialsURL,
					authDetails,
					true,
					false,
					false
				)
			);

		return testHaloPSACredentialsResponse.data;
	} catch (err) {
		return Promise.reject(err);
	}
};

export const fetchHaloPSAMetadata = async (
	authDetails: HaloPSAAuthDetails
): Promise<HaloPSAMetadata> => {
	try {
		const haloPSAMetadata: AxiosResponse<HaloPSAMetadata> = await axios(
			putRequest(FetchHaloPSAMetadataURL, authDetails, true, false, false)
		);
		return haloPSAMetadata.data;
	} catch (err) {
		return Promise.reject(err);
	}
};

export const importHaloPSATaxes = async (
	taxRegionID: string,
	deactivateExisting: boolean,
	authDetails: HaloPSAAuthDetails
): Promise<TaxInfo> => {
	try {
		const haloTaxInfo: AxiosResponse<TaxInfo> = await axios(
			postRequest(
				ImportTaxInfoURL,
				{
					tax_region_id: taxRegionID,
					deactivate_existing: deactivateExisting,
					...authDetails
				},
				true,
				false,
				false
			)
		);

		return haloTaxInfo.data;
	} catch (err) {
		return Promise.reject(err);
	}
};

export const addHaloIntegration = async (
	haloIntegrationRequest: HaloIntegrationRequest
): Promise<HaloPSAUpdateAndDeleteResponse> => {
	try {
		const response: AxiosResponse<HaloPSAUpdateAndDeleteResponse> =
			await axios(
				putRequest(
					AddHaloIntegrationURL,
					{
						...haloIntegrationRequest
					},
					true,
					false,
					false
				)
			);

		return response.data;
	} catch (err) {
		return Promise.reject(err);
	}
};

export const deleteHaloPSAIntegration =
	async (): Promise<HaloPSAUpdateAndDeleteResponse> => {
		try {
			const response: AxiosResponse<HaloPSAUpdateAndDeleteResponse> =
				await axios(
					putRequest(
						DeleteHaloPSAIntegrationURL,
						{},
						true,
						false,
						false
					)
				);
			return response.data;
		} catch (err) {
			return Promise.reject(err);
		}
	};

export const fetchHaloPSAAuthDetails =
	async (): Promise<HaloPSAAuthDetails> => {
		try {
			const response: AxiosResponse<HaloPSAAuthDetails> = await axios(
				getRequest(FetchHaloPSAAuthDetailsURL, null, true, false, false)
			);
			return response.data;
		} catch (err) {
			return Promise.reject(err);
		}
	};
